import { Component, OnInit, Input, ViewChild, ElementRef, QueryList, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomConfirmDialogService } from 'src/app/services/Non-Master/CustomConfirmDialog.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tItemService } from 'src/app/services/tItem.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { tItemModel } from 'src/app/models/tItemModel';
import { FormControl } from '@angular/forms';
import { EnglishDefaultModel, ChineseDefaultModel, SystemDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { AppComponent } from 'src/app/app.component';
import { tPackageModel } from 'src/app/models/tPackageModel';
import { tPackageService } from 'src/app/services/tPackage.service';
import { tItemCateModel } from 'src/app/models/tItemCateModel';
import { tItemCateService } from 'src/app/services/tItemCate.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { UnitItemService } from 'src/app/services/Unit/UnitItem.service';
import { UnitItemModel } from 'src/app/models/UnitItemModel';
import { AppSettings } from 'src/app/shared/AppSettings';

export class BillPaymentSearchItemPackageDialog_Case {
  public static ShoppingCart: string = "ShoppingCart";
  public static BillPay: string = "BillPay";
}
@Component({
  selector: 'app-bill-payment-search-item-package-dialog',
  templateUrl: './bill-payment-search-item-package-dialog.component.html',
  styleUrls: ['./bill-payment-search-item-package-dialog.component.css']
})
export class BillPaymentSearchItemPackageDialogComponent implements OnInit {

  selectedRowIndex: number = -1;

  itemUnitList: UnitItemModel[];

  constructor(public activeModal: NgbActiveModal,
    private router: Router,
    private customConfirmDialogService: CustomConfirmDialogService,
    private log: LoggerService,
    private route: ActivatedRoute,
    private tItemService: tItemService,
    private tPackageService: tPackageService,
    private tItemCateService: tItemCateService,
    private el: ElementRef,
    private unitItemService: UnitItemService

  ) {

  }

  searchFilterControl = new FormControl();
  searchPackageFilterControl = new FormControl();


  displayedColumns: string[] = [
    'itemID',

    // 'itemCateName',
    'itemDescAll',

    // 'itemDescMobile',

  //  'itemUnit',
    'standardPrice',
  ];


  displayedColumns_Package: string[] = [

    // 'shopID',

    'packID',
    'packDescAll',
    'packItemID',
    'packFaceAmt',
    'packRcdAmt',
    'packDisc',

    // 'lastModifyDatetime',
    // 'lastModifyUserID',
    // 'isActive'

  ];

  dataSource: MatTableDataSource<tItemModel>;
  dataSource_package: MatTableDataSource<tPackageModel>;

  dataList: tItemModel[];
  dataList_package: tPackageModel[];

  itemCateList: tItemCateModel[];

  // itemDescFilter = new FormControl();
  // itemCateIDFilter = new FormControl();

  //loading spinner
  isLoading = true;
  checkLoadingDataSource: any;
  isLoading_package = true;
  checkLoadingDataSource_package: any;
  isLoading_itemCate = true;
  // checkLoadingDataSource_itemCate: any;

  searchValue = '';
  searchPackageValue = '';

  filteredValues = {
    itemID: '', itemDescAll: ''
  };

  packageFilteredValues = {
    packID: '', packDescAll: ''
  };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("searchInput") private searchInputElement: ElementRef;
  @ViewChild("searchPackageInput") private searchPackageInputElement: ElementRef;



  TAG = 'BillPaymentSearchItemPackageDialogComponent';


  @Input() isShowItem: boolean;
  @Input() isSelectPackage: boolean;
  @Input() positionCase: string;

  ngOnInit() {
    this.setDefaultLanguageString(AppComponent.usingLanguage);

    this.getAllData();
  }


  getAllData(): void {
    if (this.isShowItem) {
      this.getItemCateData();
    }


    if (this.isSelectPackage) {
      this.getPackageData();
    }
    this.isLoading = false;

    console.log("positionCase = " + this.positionCase);

  }


  getItemCateData() {
    //itemCate list
    var shopID = NavigationComponent.selectedShopID.toString();

    if(this.positionCase==BillPaymentSearchItemPackageDialog_Case.BillPay){
      this.getAllItemCate(shopID);
    }else{
      this.getShoppingCartItemCate(shopID);
    }



    //filter by local

  }

  getShoppingCartItemCate(shopID:string){
    this.itemCateList = [new tItemCateModel()];
    this.isLoading_itemCate = false;
    this.getItemCateByConditionShoppingCart(shopID);
  }

  getItemCateByConditionShoppingCart(shopID:string){
    this.tItemCateService.getItemCateByConditionShoppingCart(shopID, "N", "N").subscribe(data => {

      //loading spinner
      this.isLoading_itemCate = false;
      this.checkLoadingDataSource_package = data;

      this.itemCateList = data;

    //  if (this.itemCateList != null && this.itemCateList.length > 0) {

        setTimeout(() => {
             this.SearchItemByItemCate(this.itemCateList[0]);
        },50);


    //  }

    }, error => this.isLoading_itemCate = false);
  }

  getAllItemCate(shopID:string){
    this.tItemCateService.getItemCateByCondition(shopID, "N", "N").subscribe(data => {

      const sortedData = AppSettings.HideItemCateOnMenuInBill.length > 0
      ? data.filter(x=> !AppSettings.HideItemCateOnMenuInBill.includes(x.itemCateID))
      : data
      ;

      //loading spinner
      this.isLoading_itemCate = false;
      this.checkLoadingDataSource_package = sortedData;

      this.itemCateList = sortedData;

    //  if (this.itemCateList != null && this.itemCateList.length > 0) {
      setTimeout(() => {
        this.SearchItemByItemCate(this.itemCateList[0]);
   },50);


    //  }

    }, error => this.isLoading_itemCate = false);
  }

  getPackageData() {
    // dataSource_package
    this.tPackageService.getActiveData().subscribe(data => {


      //loading spinner
      this.isLoading_package = false;
      this.checkLoadingDataSource_package = data;

      this.dataList_package = data;
      this.dataSource_package = new MatTableDataSource<tPackageModel>(this.dataList_package);
      this.dataSource_package.paginator = this.paginator;



      this.searchPackageFilterControl.valueChanges.subscribe((filterValue) => {
        this.packageFilteredValues['packID'] = filterValue;
        this.packageFilteredValues['packDescAll'] = filterValue;
        this.dataSource_package.filter = JSON.stringify(this.packageFilteredValues);
      });
      // this.dataSource.filterPredicate = this.customFilterPredicate();
      this.dataSource_package.filterPredicate = this.customPackageFilterPredicate();

    },
      error => this.isLoading_package = false);

  }

  resetSearch() {
    this.searchValue = '';
    this.searchPackageValue = '';

    if (this.searchInputElement != null) {
      this.searchInputElement.nativeElement.focus();
    }

    if ((this.searchPackageInputElement != null)) {
      this.searchPackageInputElement.nativeElement.focus();

    }
  }


  selectTabEvent($event) {

    this.resetSearch();
  }


  customFilterPredicate() {
    const myFilterPredicate = (data: tItemModel, filter: string): boolean => {

      let searchString = JSON.parse(filter);

      return ((searchString.itemID.toLowerCase() == '' ||
        (data.itemID != null && data.itemID.toString().trim().toLowerCase().indexOf(searchString.itemID.toLowerCase()) !== -1))
        ||
        (searchString.itemDescAll.toLowerCase() == '' ||
          (data.itemDesc != null && data.itemDesc.toString().trim().toLowerCase().indexOf(searchString.itemDescAll.toLowerCase()) !== -1))
        ||
        (searchString.itemDescAll.toLowerCase() == '' ||
          (data.itemDescEng != null && data.itemDescEng.toString().trim().toLowerCase().indexOf(searchString.itemDescAll.toLowerCase()) !== -1))
      );
    };
    return myFilterPredicate;
  }

  customPackageFilterPredicate() {
    const myFilterPredicate = (data: tPackageModel, filter: string): boolean => {

      let searchString = JSON.parse(filter);

      return ((searchString.packID.toLowerCase() == '' ||
        (data.packID != null && data.packID.toString().trim().toLowerCase().indexOf(searchString.packID.toLowerCase()) !== -1))
        ||
        (searchString.packDescAll.toLowerCase() == '' ||
          (data.packDesc != null && data.packDesc.toString().trim().toLowerCase().indexOf(searchString.packDescAll.toLowerCase()) !== -1))
        ||
        (searchString.packDescAll.toLowerCase() == '' ||
          (data.packDescEng != null && data.packDescEng.toString().trim().toLowerCase().indexOf(searchString.packDescAll.toLowerCase()) !== -1))
      );
    };
    return myFilterPredicate;
  }

  setDefaultLanguageString(language: String) {

    this.unitItemService.getActiveDatas().subscribe(data => {
      this.itemUnitList = data;
    });

  }


  selectRow(selectedModel: tItemModel, index: number) {

    this.log.i(this.TAG, "selectRow = " + selectedModel.itemID.toString());

    const itemUnitStr = this.itemUnitList.find(p => p.itemUnitID === selectedModel.itemUnit).itemUnitName;


    this.log.i(this.TAG, itemUnitStr);

    this.selectedRowIndex = index;


    // switch (this.tableKeyValue) {
    //   case MastersKeyStringValue.TABLE_ItemCate:
    //     this.tItemService.shareSelected(selectedModel.itemID.toString(),
    //       selectedModel.itemDesc.toString(),
    //       itemUnitStr,
    //       selectedModel.standardPrice);
    //     break;
    //   case MastersKeyStringValue.TABLE_PriceBook:
    //     // this.tItemService.shareSelectedPriceBook(selectedModel);
    //     break;
    //   default:
    //     this.tItemService.shareSelected(selectedModel.itemID.toString(),
    //       selectedModel.itemDesc.toString(),
    //       itemUnitStr,
    //       selectedModel.standardPrice);
    //     break;

    // }

    this.tItemService.shareSelected(selectedModel.itemID.toString(),
      selectedModel.itemDesc.toString(),
      itemUnitStr,
      selectedModel.standardPrice);

    this.activeModal.close({ returnModel: "itemModel", data: selectedModel });
  }


  selectRow_Package(selectedModel: tPackageModel, index: number) {

    this.log.i(this.TAG, "selectRow_Package = " + selectedModel.packID.toString());

    this.activeModal.close({ returnModel: "packageModel", data: selectedModel });

  }



  SearchItemByItemCate(selectedItemCate: tItemCateModel) {
    console.log("Testing");
    var shopID = NavigationComponent.selectedShopID.toString();
    var selectedItemCateID = selectedItemCate.itemCateID;

    console.log(this.TAG, "do SearchItemByItemCate itemCate id =" + selectedItemCateID);

    //select itemCate change color
    for (var p = 0; p < this.itemCateList.length; p++) {
      var checkingItemCateID = this.itemCateList[p].itemCateID;

      var targetElement = this.el.nativeElement.querySelector('#navList_' + checkingItemCateID);
      var targetElement2 = this.el.nativeElement.querySelector('#listBox_' + checkingItemCateID);
      console.log(targetElement);
      if (targetElement != null) {
        if (checkingItemCateID == selectedItemCateID) {
          //listSelected
          targetElement.classList.add('listSelected');
          targetElement2.classList.add('selectedItemCate');
        } else {
          targetElement.classList.remove('listSelected');
          targetElement2.classList.remove('selectedItemCate');

        }
      }

    }

    //spinner run
    this.isLoading = true;
    //get the item info
    this.tItemService.getItemListByItemCateID(shopID, selectedItemCateID).subscribe(data => {

      //loading spinner
      this.isLoading = false;
      this.checkLoadingDataSource = data;

      this.dataList = data;
      this.dataSource = new MatTableDataSource<tItemModel>(this.dataList);
      this.dataSource.paginator = this.paginator;


      this.searchFilterControl.valueChanges.subscribe((filterValue) => {
        this.filteredValues['itemID'] = filterValue;
        this.filteredValues['itemDescAll'] = filterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });
      // this.dataSource.filterPredicate = this.customFilterPredicate();
      this.dataSource.filterPredicate = this.customFilterPredicate();


      this.resetSearch()



    },
      error => this.isLoading = false);

  }


  getItemUnitListName(id: number) {
    return this.itemUnitList.find(p => p.itemUnitID === id).itemUnitName;
  }

}
